import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config/Config";
import { formatDate } from "../utils/formatters";

export default function ProjectDetail() {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/posts/${projectId}`)
      .then((res) => {
        setProject(res.data.data);
      })
      .catch((err) => {
        console.error("Ошибка при загрузке проекта:", err);
        setError("Проект не найден");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [projectId]);

  if (loading) {
    return (
      <section className="min-h-screen pt-24 pb-20 px-6 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#4f9067]"></div>
      </section>
    );
  }

  if (error || !project) {
    return (
      <section className="min-h-screen pt-24 pb-20 px-6 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-red-500 mb-4">
            {error || "Проект не найден"}
          </h1>
          <Link
            to="/projects"
            className="inline-block bg-[#4f9067] text-white px-6 py-2 rounded-lg hover:bg-[#3f7252] transition"
          >
            Вернуться к проектам
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section className="min-h-screen pt-24 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        {/* Навигация */}
        <Link
          to="/projects"
          className="inline-flex items-center text-[#4f9067] hover:text-[#3f7252] mb-6 transition"
        >
          <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Назад к проектам
        </Link>

        {/* Изображение */}
        {project.image_url && (
          <div className="rounded-2xl overflow-hidden shadow-lg mb-8">
            <img
              src={project.image_url}
              alt={project.title}
              className="w-full h-auto max-h-[500px] object-cover"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </div>
        )}

        {/* Дополнительные изображения */}
        {project.image_urls && project.image_urls.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
            {project.image_urls.map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`${project.title} - ${index + 1}`}
                className="rounded-lg w-full h-32 object-cover"
              />
            ))}
          </div>
        )}

        {/* Контент */}
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[#4f9067] mb-4">
            {project.title}
          </h1>

          {project.created_at && (
            <p className="text-gray-500 mb-6">
              {formatDate(project.created_at)}
            </p>
          )}

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {project.text}
            </p>
          </div>
        </div>

        {/* Видео */}
        {project.video_urls && project.video_urls.length > 0 && (
          <div className="mt-8">
            <h2 className="text-2xl font-bold text-[#4f9067] mb-4">Видео</h2>
            <div className="grid gap-4">
              {project.video_urls.map((url, index) => (
                <video
                  key={index}
                  src={url}
                  controls
                  className="w-full rounded-lg"
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
